import React from 'react';
import { Search as SearchIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { CenteredFab } from './CustomButton';
import COLORS from '../../Utils/colors';

interface UserSearchFabProps {
  visible?: boolean;
}

const UserSearchFab: React.FC<UserSearchFabProps> = ({ visible = true }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/user-search');
  };

  if (!visible) return null;

  return (
    <CenteredFab
      icon={<SearchIcon />}
      label="search users"
      onClick={handleClick}
      position="end"
      sx={{
        backgroundColor: COLORS.primary,
        color: 'white',
        '&:hover': {
          backgroundColor: COLORS.burntOrange,
        }
      }}
    />
  );
};

export default UserSearchFab;
